module.exports = __webpack_public_path__ + "static/media/logo-black.25b6dfd5.svg";